import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", null, "Chọn tháng để xem", -1)
const _hoisted_5 = {
  key: 0,
  class: "p-field p-col-12 p-md-6"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("label", null, "Chọn khoa khám bệnh", -1)
const _hoisted_7 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_8 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_9 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_10 = { class: "input" }
const _hoisted_11 = {
  class: "p-input-icon-left",
  style: {"width":"25em"}
}
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Không có lượt đăng ký khám bệnh. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Chart = _resolveComponent("Chart")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_Panel = _resolveComponent("Panel")

  return (_openBlock(), _createBlock(_component_Panel, { header: "Thống kê lịch đăng ký" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_Calendar, {
              id: "date",
              modelValue: $setup.date,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.date = $event)),
              view: "month",
              dateFormat: "mm/yy",
              yearNavigator: true,
              yearRange: "2000:2099",
              showButtonBar: true,
              showIcon: true,
              manualInput: false,
              disabled: $setup.isLoading,
              onDateSelect: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadBook()))
            }, null, 8, ["modelValue", "disabled"])
          ]),
          ($setup.master)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Dropdown, {
                  id: "team",
                  filter: true,
                  showClear: true,
                  modelValue: $setup.selectTeam,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.selectTeam = $event)),
                  options: $setup.teams,
                  optionLabel: "name",
                  optionValue: "name",
                  placeholder: "Vui lòng lựa chọn khoa khám...",
                  onChange: $setup.select
                }, null, 8, ["modelValue", "options", "onChange"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_7, [
            ($setup.selectedGroup.length > 0)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  type: "button",
                  label: "Biểu đồ thống kê lượt đăng ký khám trong tháng",
                  icon: "pi pi-chart-bar",
                  class: "p-button-raised",
                  onClick: $setup.groups
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_Button, {
              type: "button",
              label: "Biểu đồ thống kê lượt đăng ký khám trong năm",
              icon: "pi pi-chart-bar",
              class: "p-button-raised",
              onClick: $setup.countYear
            }, null, 8, ["onClick"])
          ])
        ]),
        _createVNode(_component_DataTable, {
          loading: $setup.isLoading,
          value: $setup.books,
          paginator: true,
          stripedRows: "",
          filters: $setup.filters,
          "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => ($setup.filters = $event)),
          rows: 10,
          rowsPerPageOptions: [10,25,50],
          rowHover: true,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          globalFilterFields: ['full_name','phone_number'],
          currentPageReportTemplate: "Có tất cả {totalRecords} lượt đăng ký khám bệnh"
        }, {
          header: _withCtx(() => [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-filter-slash",
                  label: "Xoá",
                  class: "p-button-outlined",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.clearFilter())),
                  style: {"width":"6em"}
                })
              ]),
              _createVNode("span", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_InputText, {
                  modelValue: $setup.filters['global'].value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($setup.filters['global'].value = $event)),
                  placeholder: "Tìm theo tên bệnh nhân hoặc số điện thoại..."
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          paginatorLeft: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-refresh",
              class: "p-button-text",
              onClick: $setup.loadBook
            }, null, 8, ["onClick"])
          ]),
          empty: _withCtx(() => [
            _hoisted_13
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "full_name",
              header: "Họ và tên",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "phone_number",
              header: "Số điện thoại"
            }),
            _createVNode(_component_Column, {
              field: "symptoms",
              header: "Triệu chứng",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "team",
              header: "Khoa khám bệnh",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "formatted_time",
              header: "Thời gian",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "date_register",
              dataType: "date",
              header: "Ngày khám bệnh",
              sortable: ""
            })
          ]),
          _: 1
        }, 8, ["loading", "value", "filters"])
      ]),
      _createVNode(_component_Dialog, {
        header: "Biểu đồ thống kê lượt đăng ký khám trong tháng",
        visible: $setup.displayPopup,
        "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ($setup.displayPopup = $event)),
        style: {"width":"50em"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Chart, {
            type: "pie",
            data: $setup.totalData,
            options: $setup.chartOptions
          }, null, 8, ["data", "options"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        header: "Biểu đồ thống kê lượt đăng ký khám trong năm",
        visible: $setup.countInYear,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ($setup.countInYear = $event)),
        style: {"width":"50em"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Chart, {
            type: "bar",
            data: $setup.totalDataCount,
            options: $setup.chartOptions
          }, null, 8, ["data", "options"])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }))
}